export default __webpack_public_path__ + "static/media/AssetTable.3ec9fec0.webp";